
function getBlogs(setBlogs, setLoading ) {
  const url =
    "https://www.googleapis.com/blogger/v3/blogs/460807346859212205/posts?key=AIzaSyBqKzXCCGSnRfDLxIZ7R64sIv7L3KlzJ10&maxResults=7";
  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      const items = data.items || [];
      setBlogs(items);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
}

function getBlog(postId, setBlog, setLoading) {
  const url = `https://www.googleapis.com/blogger/v3/blogs/460807346859212205/posts/${postId}?key=AIzaSyBqKzXCCGSnRfDLxIZ7R64sIv7L3KlzJ10`;

  fetch(url)
    .then((response) => response.json())
    .then((data) => {
      setBlog(data);
      setLoading(false);
    })
    .catch((error) => {
      setLoading(false);
    });
}

function extractImageFromContent(htmlContent) {
  const imgRegex = /<img[^>]+src="([^">]+)"/;
  const match = htmlContent.match(imgRegex);
  return match ? match[1] : null;
};

function stripHtml(html) {
  const tmp = document.createElement("DIV");
  tmp.innerHTML = html;
  return tmp.textContent || tmp.innerText || "";
};

export { getBlogs, getBlog, extractImageFromContent, stripHtml };